import React, { useState, useEffect, useContext } from 'react';
import { Typography, Row, Col, Button } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import API from '../../../api/API';
import { UserContext } from '../../../contexts';
import { INotification } from '../../../models/notification';
import { LoadingScreen } from '../event';
import './Home.less';

const { Title, Text, Link } = Typography;

const Home: React.FC = () => {
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);
  const history = useHistory();

  useEffect(() => {
    document.title = 'EHE Tracker - Home';
  }, []);

  useEffect(() => {
    const fetchNotificationCount = async (username: string) => {
      const resp = await API.get(`/notification/${username}`, {
        params: {
          limit: 10,
          offset: 0,
          read: false,
        },
      });

      const data = resp.data as INotification[];

      if (data.length !== 0) {
        setNotificationCount(data[0].total);
      }
      setLoading(false);
    };

    try {
      fetchNotificationCount(user.username);
    } catch (e) {
      setLoading(true);
    }
  }, [user.username]);

  const onNotificationButtonClick = () => {
    history.push('/notifications');
  };

  return loading ? (
    <LoadingScreen />
  ) : (
    <Row>
      <Col span={14}>
        <Row gutter={16}>
          <Col>
            <Title>EHE Tracker</Title>
          </Col>
          <Col>
            {notificationCount !== 0 && (
              <Button
                type="primary"
                icon={<BellOutlined />}
                size="large"
                className="Home-notification-button"
                onClick={onNotificationButtonClick}
              >
                <span>{notificationCount}</span>
              </Button>
            )}
          </Col>
        </Row>
        <Text className="Home-text">
          The Event Tracker captures the U.S. Department of Health & Human
          Services (HHS) agencies&apos; participation in events related to EHE.
        </Text>
        <Row className="Home-section-margin">
          <Text className="Home-text">
            Contributions are reviewed weekly by Oskian Kouzouian (
            <Link href="mailto:Oskian.Kouzouian@hhs.gov">
              Oskian.Kouzouian@hhs.gov
            </Link>
            ) and Lauren Rowson (
            <Link href="mailto:Lauren.Rowson@icfnext.com">
              Lauren.Rowson@icfnext.com
            </Link>
            ), typically on Friday mornings.
          </Text>
        </Row>
      </Col>
    </Row>
  );
};

export default Home;
